import { SectionItem } from '@app/shell/SiteHeader/shared/types/MobileMenuSection';

const SNEAKERS = {
  title: 'Sneakers',
  link: 'sneakers',
  submenu: [
    {
      title: 'Popular Brands',
      submenu: [
        {
          title: 'Air Jordan',
          urlKey: 'retro-jordans',
        },
        {
          title: 'adidas',
          urlKey: 'adidas',
        },
        {
          title: 'Converse',
          urlKey: 'converse',
        },
        {
          title: 'New Balance',
          urlKey: 'new-balance',
        },
        {
          title: 'Nike',
          urlKey: 'nike',
        },
        {
          title: 'Puma',
          urlKey: 'puma',
        },
        {
          title: 'Yeezy',
          urlKey: 'yeezy',
        },
      ],
    },
    {
      title: 'Top Models',
      submenu: [
        {
          title: 'Air Jordan 1',
          urlKey: 'retro-jordans/air-jordan-1',
        },
        {
          title: 'Air Jordan 4',
          urlKey: 'retro-jordans/air-jordan-4',
        },
        {
          title: 'Air Jordan 11',
          urlKey: 'retro-jordans/air-jordan-11',
        },
        {
          title: 'Nike Dunk',
          urlKey: 'nike/dunk',
        },
        {
          title: 'Nike Air Force 1',
          urlKey: 'nike/air-force/1',
        },
        {
          title: 'Nike Air Max',
          urlKey: 'nike/air-max',
        },
        {
          title: 'New Balance 550',
          urlKey: 'nike/new-balance/550',
        },
      ],
    },
    {
      title: 'Steals & Deals',
      submenu: [
        {
          title: 'Under $100',
          urlKey: 'sneakers?prices=100',
        },
        {
          title: 'Under $200',
          urlKey: 'sneakers?prices=100-200%2C100',
        },
        {
          title: 'Under $300',
          urlKey: 'sneakers?prices=200-300%2C100-200%2C100',
        },
        {
          title: 'Below Retail',
          urlKey: 'sneakers?belowRetail=true',
        },
        {
          title: 'Trending Deals',
          urlKey: 'sneakers?trending_deals=true',
        },
      ],
    },
    {
      title: 'More Brands',
      submenu: [
        {
          title: 'ASICS',
          urlKey: 'other-sneakers/asics',
        },
        {
          title: 'BAPE',
          urlKey: 'other-sneakers/a-bathing-ape',
        },
        {
          title: 'Hoka One One',
          urlKey: 'other-sneakers/hoka-one-one',
        },
        {
          title: 'On',
          urlKey: 'other-sneakers/on',
        },
        {
          title: 'Salomon',
          urlKey: 'other-sneakers/salomon',
        },
        {
          title: 'Under Armour',
          urlKey: 'other-sneakers/under-armour',
        },
        {
          title: 'Vans',
          urlKey: 'vans',
        },
      ],
    },
    {
      title: 'Luxury Brands',
      submenu: [
        {
          title: 'Alexander McQueen',
          urlKey: 'luxury-brands/alexander-mcqueen',
        },
        {
          title: 'Balenciaga',
          urlKey: 'luxury-brands/balenciaga-sneakers',
        },
        {
          title: 'Common Projects',
          urlKey: 'luxury-brands/common-projects',
        },
        {
          title: 'Gucci',
          urlKey: 'luxury-brands/gucci-sneakers',
        },
        {
          title: 'Lanvin',
          urlKey: 'luxury-brands/Lanvin',
        },
        {
          title: 'Louis Vuitton',
          urlKey: 'luxury-brands/louis-vuitton-sneakers',
        },
        {
          title: 'OFF-WHITE',
          urlKey: 'luxury-brands/off-white-shoes',
        },
      ],
    },
  ],
};

const SHOES = {
  title: 'Shoes',
  link: 'shoes',
  submenu: [
    {
      title: 'Top Brands',
      submenu: [
        { title: 'Birkenstock', urlKey: 'birkenstock' },
        { title: 'Crocs', urlKey: 'crocs' },
        { title: 'Dr. Martens', urlKey: 'dr-martens' },
        { title: 'Timberland', urlKey: 'timberland' },
        { title: 'UGG', urlKey: 'ugg' },
      ],
    },
    {
      title: 'Steals & Deals',
      submenu: [
        { title: 'Under $100', urlKey: 'shoes?prices=100' },
        { title: 'Under $250', urlKey: 'shoes?prices=100-250%2C100' },
        { title: 'Under $500', urlKey: 'shoes?prices=250-500%2C100-250%2C100' },
        { title: 'Below Retail', urlKey: 'shoes?belowRetail=true' },
        { title: 'Trending Deals', urlKey: 'shoes?trending_deals=true' },
      ],
    },
    {
      title: 'Discover More',
      submenu: [
        { title: 'Gucci Slides', urlKey: 'gucci-shoes/slides-sandals' },
        { title: 'Timberland Boots', urlKey: 'timberland/boots' },
        { title: 'UGG Slippers', urlKey: 'ugg/slippers' },
        { title: 'UGG Boots', urlKey: 'ugg/boots' },
      ],
    },
    {
      title: 'Top Products',
      submenu: [
        { title: 'Birkenstock Boston', urlKey: 'search?s=birkenstock+boston' },
        {
          title: 'Crocs Lightning McQueen',
          urlKey: 'crocs-classic-clog-lightning-mcqueen',
          isProduct: true,
        },
        {
          title: 'Crocs by Salehe Bembury',
          urlKey: 'search?s=crocs+salehe+bembury',
        },
        { title: 'Timberland 6” Boot', urlKey: 'search?s=timberland+6+boot' },
        {
          title: 'UGG Classic Ultra Mini',
          urlKey: 'search?s=ugg+classic+ultra+mini',
        },
        { title: 'UGG Tasman Slipper', urlKey: 'search?s=ugg+tasman+slipper' },
        {
          title: 'UGG Tazz Platform Slipper',
          urlKey: 'search?s=ugg+tazz+slipper',
        },
      ],
    },
    {
      title: 'Luxury Brands',
      submenu: [
        { title: 'Gucci', urlKey: 'gucci-shoes' },
        { title: 'Balenciaga', urlKey: 'balenciaga-shoes' },
        { title: 'Dior', urlKey: 'dior-shoes' },
        { title: 'Prada', urlKey: 'prada-shoes' },
        { title: 'Chanel', urlKey: 'chanel-shoes' },
        { title: 'Hermes', urlKey: 'hermes-shoes' },
        { title: 'Versace', urlKey: 'versace-shoes' },
      ],
    },
  ],
};

const TRADING_CARDS = {
  title: 'Trading Cards',
  link: 'trading-cards',
  submenu: [
    {
      title: 'Popular Brands',
      submenu: [
        { title: 'Pokemon', urlKey: 'pokemon-cards' },
        { title: 'Panini', urlKey: 'search/trading-cards?s=panini' },
        { title: 'Topps', urlKey: 'search/trading-cards?s=topps' },
        { title: 'Bandai', urlKey: 'search/trading-cards?s=bandai' },
        { title: 'Yu-Gi-Oh!', urlKey: 'yu-gi-oh-tcg' },
        { title: 'Bowmen', urlKey: 'search/trading-cards?s=bowmen' },
        { title: 'Upper Deck', urlKey: 'search/trading-cards?s=upper+deck' },
      ],
    },
    {
      title: 'Shop by Category',
      submenu: [
        { title: 'TCG', urlKey: 'search/trading-cards?s=tgc' },
        { title: 'Basketball', urlKey: 'basketball-cards' },
        { title: 'Baseball', urlKey: 'baseball' },
        { title: 'Football', urlKey: 'football-cards' },
        { title: 'Other Sports', urlKey: 'other-sports' },
        { title: 'Lots', urlKey: 'search/trading-cards?s=lots' },
        { title: 'Sealed Cases', urlKey: 'sealed-boxes' },
      ],
    },
    {
      title: 'Steals & Deals',
      submenu: [
        {
          title: 'Under $500',
          urlKey:
            'trading-cards?prices=400-500%2C300-400%2C200-300%2C100-200%2C100',
        },
        { title: 'Under $200', urlKey: 'trading-cards?prices=100-200%2C100' },
        { title: 'Under $100', urlKey: 'trading-cards?prices=100' },
        { title: 'Below Retail', urlKey: 'trading-cards?belowRetail=true' },
        {
          title: 'Trending Deals',
          urlKey: 'trading-cards?trending_deals=true',
        },
        { title: 'New Releases', urlKey: 'trading-cards/release-date' },
      ],
    },
  ],
};

const APPAREL = {
  title: 'Apparel',
  link: 'apparel',
  submenu: [
    {
      title: 'Popular Brands',
      submenu: [
        { title: 'Supreme', urlKey: 'supreme' },
        { title: 'FOG Essentials', urlKey: 'fear-of-god' },
        { title: 'Nike', urlKey: 'nike-apparel' },
        { title: 'Travis Scott', urlKey: 'artist-merch/travis-scott-apparel' },
        { title: 'Sp5der', urlKey: 'sp5der' },
        { title: 'Stussy', urlKey: 'stussy' },
        { title: 'Artist Merch', urlKey: 'artist-merch' },
      ],
    },
    {
      title: 'Steals & Deals',
      submenu: [
        { title: 'Under $100', urlKey: 'apparel?prices=50-100%2Cunder-50' },
        {
          title: 'Under $250',
          urlKey: 'apparel?prices=100-250%2C50-100%2Cunder-50',
        },
        {
          title: 'Under $500',
          urlKey: 'apparel?prices=250-500%2C100-250%2C50-100%2Cunder-50',
        },
        { title: 'Below Retail', urlKey: 'apparel?belowRetail=true' },
        { title: 'Trending Deals', urlKey: 'apparel?trending_deals=true' },
        { title: 'New Releases', urlKey: 'apparel/release-date' },
      ],
    },
    {
      title: 'Designer Brands',
      submenu: [
        { title: 'Off-White', urlKey: 'off-white' },
        { title: 'Chrome Hearts', urlKey: 'chrome-hearts' },
        { title: 'Palm Angels', urlKey: 'palm-angels' },
        { title: 'CDG Play', urlKey: 'comme-des-garcons-play' },
        { title: 'Burberry', urlKey: 'other-apparel/burberry-apparel' },
        { title: 'Aime Leon Dore', urlKey: 'other-apparel/aime-leon-dore' },
        { title: 'Amiri', urlKey: 'other-apparel/amiri' },
      ],
    },
    {
      title: 'Emerging Brands',
      submenu: [
        { title: 'Arc’Teryx', urlKey: 'other-apparel/arcteryx' },
        { title: 'Gallery Dept. ', urlKey: 'gallery-dept' },
        { title: 'drew house', urlKey: 'drew-house' },
        { title: 'Kith', urlKey: 'kith' },
        { title: 'Corteiz', urlKey: 'other-apparel/corteiz' },
        { title: 'Trapstar', urlKey: 'other-apparel/trapstar' },
        { title: 'Eric Emmanuel', urlKey: 'eric-emanuel' },
      ],
    },
    {
      title: 'Shop by Category',
      submenu: [
        { title: 'T-shirts', urlKey: 'search/apparel?s=t-shirt' },
        { title: 'Shirts', urlKey: 'search/apparel?s=shirt' },
        {
          title: 'Hoodies & Sweatshirts',
          urlKey: 'search/apparel?s=sweatshirt',
        },
        { title: 'Shorts', urlKey: 'search/apparel?s=shorts' },
        { title: 'Sweatpants', urlKey: 'search/apparel?s=sweatpants' },
        { title: 'Pants', urlKey: 'search/apparel?s=pants' },
        { title: 'Jackets & Coats', urlKey: 'search/apparel?s=jacket' },
      ],
    },
  ],
};

const ACCESSORIES = {
  title: 'Accessories',
  link: 'accessories',
  submenu: [
    {
      title: 'Popular Brands',
      submenu: [
        { title: 'Swatch', urlKey: 'swatch-x-omega' },
        { title: 'Supreme', urlKey: 'supreme-accessories' },
        { title: 'Telfar', urlKey: 'telfar' },
        { title: 'Casio', urlKey: 'casio-g-shock' },
        { title: 'Off-White', urlKey: 'off-white-accessories' },
        { title: 'BAPE', urlKey: 'bape-accessories' },
        { title: 'Chrome Hearts', urlKey: 'chrome-hearts-accessories' },
      ],
    },
    {
      title: 'Luxury Brands',
      submenu: [
        { title: 'Gucci', urlKey: 'gucci' },
        { title: 'Louis Vuitton', urlKey: 'louis-vuitton' },
        { title: 'Goyard', urlKey: 'goyard' },
        { title: 'Chanel', urlKey: 'chanel' },
        { title: 'Dior', urlKey: 'dior-accessories' },
        { title: 'Saint Laurent', urlKey: 'saint-laurent' },
        { title: 'Prada', urlKey: 'prada' },
      ],
    },
    {
      title: 'Shop by Category',
      submenu: [
        { title: 'Backpacks', urlKey: 'accessories/backpack' },
        { title: 'Belts', urlKey: 'accessories/belt' },
        { title: 'Card Cases', urlKey: 'accessories/cardcase' },
        { title: 'Crossbody Bags', urlKey: 'accessories/crossbody' },
        { title: 'Headwear', urlKey: 'accessories/designer-headwear' },
        { title: 'Sunglasses', urlKey: 'accessories/sunglasses' },
        { title: 'Watches', urlKey: 'accessories/watches' },
      ],
    },
    {
      title: 'Steals & Deals',
      submenu: [
        { title: 'Under $500', urlKey: 'accessories?prices=under-500' },
        {
          title: 'Under $1,500',
          urlKey: 'accessories?prices=500-1500%2Cunder-500',
        },
        {
          title: 'Under $3,000',
          urlKey: 'accessories?prices=1500-3000%2C500-1500%2Cunder-500',
        },
        { title: 'Below Retail', urlKey: 'accessories?belowRetail=true' },
        { title: 'Trending Deals', urlKey: 'accessories?trending_deals=true' },
        { title: 'New Releases', urlKey: 'accessories/release-date' },
      ],
    },
    {
      title: 'Discover More',
      submenu: [
        {
          title: 'Swatch x Omega Moonswatch',
          urlKey: 'search/swatch-x-omega?s=moonswatch',
        },
        { title: 'Rolex', urlKey: 'rolex' },
        { title: 'Marc Jacobs', urlKey: 'other-accessories/marc-jacobs' },
        { title: 'Diesel', urlKey: 'other-accessories/diesel-accessories' },
        { title: 'Bottega Veneta', urlKey: 'other-accessories/bottega-veneta' },
      ],
    },
  ],
};

const ELECTRONICS = {
  title: 'Electronics',
  link: 'electronics',
  submenu: [
    {
      title: 'Popular Brands',
      submenu: [
        { title: 'Apple', urlKey: 'apple' },
        { title: 'Playstation', urlKey: 'playstation' },
        { title: 'Xbox', urlKey: 'xbox' },
        { title: 'Nvidia', urlKey: 'nvidia' },
        { title: 'Nintendo', urlKey: 'nintendo' },
        { title: 'Beats', urlKey: 'beats' },
        { title: 'Finalmouse', urlKey: 'finalmouse' },
      ],
    },
    {
      title: 'Shop by Category',
      submenu: [
        { title: 'iPhones', urlKey: 'search/apple?s=iphone' },
        { title: 'Macbooks', urlKey: 'search/apple?s=macbook' },
        { title: 'Ipads', urlKey: 'search/apple?s=ipad' },
        { title: 'Certified Refurbished', urlKey: 'certified-refurbished' },
      ],
    },
    {
      title: 'Top Models',
      submenu: [
        { title: 'PS5', urlKey: 'playstation/ps5' },
        { title: 'Xbox', urlKey: 'xbox' },
        { title: 'Nintendo Switch', urlKey: 'nintendo/switch' },
        { title: 'Macbooks', urlKey: 'search/apple?s=macbook' },
        { title: 'Finalmouse', urlKey: 'finalmouse' },
        { title: 'Certified Refurbished', urlKey: 'certified-refurbished' },
      ],
    },
    {
      title: 'Steals & Deals',
      submenu: [
        {
          title: 'Under $500',
          urlKey:
            'electronics?prices=400-500%2C300-400%2C200-300%2C100-200%2C100',
        },
        { title: 'Under $200', urlKey: 'electronics?prices=100-200%2C100' },
        { title: 'Below Retail', urlKey: 'electronics?belowRetail=true' },
        { title: 'Trending Deals', urlKey: 'electronics?trending_deals=true' },
        { title: 'New Releases', urlKey: 'electronics/release-date' },
      ],
    },
    {
      title: 'Discover More',
      submenu: [
        {
          title: 'Flipper Zero',
          urlKey: 'flipper-zero-portable-multitool',
          isProduct: true,
        },
        { title: 'Higround', urlKey: 'higround' },
        { title: 'Beats', urlKey: 'beats' },
        { title: 'Sony', urlKey: 'search/electronics?s=sony' },
        { title: 'Samsung', urlKey: 'samsung' },
      ],
    },
  ],
};

const COLLECTIBLES = {
  title: 'Collectibles',
  link: 'collectibles',
  submenu: [
    {
      title: 'Popular Brands',
      submenu: [
        { title: 'BAPE', urlKey: 'search/collectibles?s=bape' },
        { title: 'Bearbrick', urlKey: 'bearbrick' },
        { title: 'Funko', urlKey: 'funko-pop' },
        { title: 'Hot Wheels', urlKey: 'other-collectibles/hot-wheels' },
        { title: 'KITH', urlKey: 'other-collectibles/kith-collectibles' },
        { title: 'LEGO', urlKey: 'lego' },
        { title: 'Supreme', urlKey: 'other-collectibles/supreme-collectibles' },
      ],
    },
    {
      title: 'Top Artists',
      submenu: [
        { title: 'Daniel Arsham', urlKey: 'daniel-arsham' },
        { title: 'Hebru Brantley', urlKey: 'art-prints/hebru-brantley' },
        { title: 'KAWS', urlKey: 'kaws' },
        { title: 'Takashi Murkami', urlKey: 'takashi-murakami-collectibles' },
        { title: 'Travis Scott', urlKey: 'other-collectibles/travis-scott' },
        { title: 'Virgil Abloh', urlKey: 'virgil-abloh' },
      ],
    },
    {
      title: 'Steals & Deals',
      submenu: [
        { title: 'Under $100', urlKey: 'collectibles?prices=100' },
        { title: 'Under $200', urlKey: 'collectibles?prices=100-200%2C100' },
        {
          title: 'Under $300',
          urlKey: 'collectibles?prices=200-300%2C100-200%2C100',
        },
        { title: 'Below Retail', urlKey: 'collectibles?belowRetail=true' },
        { title: 'Trending Deals', urlKey: 'collectibles?trending_deals=true' },
      ],
    },
    {
      title: 'Discover More',
      submenu: [
        { title: 'Action Figures', urlKey: 'action-figures' },
        { title: 'Art Prints', urlKey: 'art-prints' },
        {
          title: 'Books & Magazines',
          urlKey: 'other-collectibles/books-magazines',
        },
        { title: 'Comic Books', urlKey: 'comic-books' },
        { title: 'Skate Decks', urlKey: 'skate-decks' },
        {
          title: 'Vinyl Records',
          urlKey: 'other-collectibles/vinyl-records-music',
        },
      ],
    },
    {
      title: 'Viral Products',
      submenu: [
        {
          title: 'Xbox Mini Fridge',
          urlKey: 'search/collectibles?s=xbox+mini+fridge',
        },
        {
          title: 'CPFM x McDonald’s Toys',
          urlKey: 'search/collectibles?s=cpfm',
        },
        {
          title: 'Hot Wheels x Tesla Cybertruck',
          urlKey: 'search/other-collectibles/hot-wheels?s=tesla+cybertruck',
        },
        {
          title: 'LEGO x The Office',
          urlKey: 'lego-ideas-the-office-set-21336',
          isProduct: true,
        },
        {
          title: 'Supreme Beanie Baby',
          urlKey: 'supreme-ty-beanie-baby-multicolor',
          isProduct: true,
        },
        {
          title: 'Daniel Arsham IKEA Clock',
          urlKey: 'ikea-art-event-2021-daniel-arsham-clock',
          isProduct: true,
        },
        {
          title: 'Virgil Abloh x Nike Book',
          urlKey: 'search/collectibles?s=virgil+nike+book',
        },
      ],
    },
  ],
};

const MEN = {
  title: 'Men',
  link: 'sneakers?size_types=men',
  submenu: [
    {
      title: 'Sneakers',
      link: 'sneakers?size_types=men',
      submenu: [
        { title: 'Air Jordan', urlKey: 'retro-jordans?size_types=men' },
        { title: 'adidas', urlKey: 'adidas?size_types=men' },
        { title: 'Converse', urlKey: 'converse?size_types=men' },
        { title: 'New Balance', urlKey: 'new-balance?size_types=men' },
        { title: 'Nike', urlKey: 'nike?size_types=men' },
        { title: 'Puma', urlKey: 'puma?size_types=men' },
        { title: 'Yeezy', urlKey: 'yeezy?size_types=men' },
      ],
    },
    {
      title: 'Shoes',
      link: 'shoes?size_types=men',
      submenu: [
        { title: 'Birkenstock', urlKey: 'birkenstock?size_types=men' },
        { title: 'Crocs', urlKey: 'crocs?size_types=men' },
        { title: 'Dr. Martens', urlKey: 'dr-martens?size_types=men' },
        { title: 'Gucci', urlKey: 'gucci-shoes?size_types=men' },
        { title: 'Timberland', urlKey: 'timberland?size_types=men' },
        { title: 'UGG', urlKey: 'ugg?size_types=men' },
      ],
    },
    {
      title: 'Apparel',
      link: 'apparel?gender=men',
      submenu: [
        {
          title: 'FOG Essentials',
          urlKey: 'fear-of-god-essentials?gender=men',
        },
        { title: 'Nike', urlKey: 'nike-apparel?gender=men' },
        { title: 'Supreme', urlKey: 'supreme?gender=men' },
        { title: 'Sp5der', urlKey: 'sp5der?gender=men' },
        { title: 'BAPE', urlKey: 'bape?gender=men' },
        {
          title: 'Anti Social Social Club',
          urlKey: 'other-apparel/anti-social-social-club?gender=men',
        },
        { title: 'Artist Merch', urlKey: 'artist-merch?gender=men' },
      ],
    },
    {
      title: 'Accessories',
      link: 'accessories?gender=men',
      submenu: [
        { title: 'Supreme', urlKey: 'supreme-accessories?gender=men' },
        { title: 'Louis Vuitton', urlKey: 'louis-vuitton?gender=men' },
        { title: 'Gucci', urlKey: 'gucci?gender=men' },
        { title: 'Goyard', urlKey: 'goyard?gender=men' },
        { title: 'Off-White', urlKey: 'off-white-accessories?gender=men' },
        { title: 'BAPE', urlKey: 'bape-accessories?gender=men' },
        { title: 'Chrome Hearts', urlKey: 'chrome-hearts-accessories' },
      ],
    },
    {
      title: 'Shop by Category',
      submenu: [
        { title: 'T-Shirts', urlKey: 'search/apparel?gender=men&s=tee' },
        { title: 'Bottoms', urlKey: 'search/apparel?gender=men&s=bottom' },
        {
          title: 'Jackets & Coats',
          urlKey: 'search/apparel?gender=men&s=jacket',
        },
        { title: 'Watches', urlKey: 'accessories/watches?gender=men' },
        { title: 'Sunglasses', urlKey: 'accessories/sunglasses?gender=men' },
        { title: 'Wallets', urlKey: 'accessories/wallet?gender=men' },
        { title: 'Belts', urlKey: 'accessories/belt?gender=men' },
      ],
    },
  ],
};

const WOMEN = {
  title: 'Women',
  link: 'sneakers?size_types=women',
  submenu: [
    {
      title: 'Sneakers',
      link: 'sneakers?size_types=women',
      submenu: [
        { title: 'Air Jordan', urlKey: 'retro-jordans?size_types=women' },
        { title: 'adidas', urlKey: 'adidas?size_types=women' },
        { title: 'Converse', urlKey: 'converse?size_types=women' },
        { title: 'New Balance', urlKey: 'new-balance?size_types=women' },
        { title: 'Nike', urlKey: 'nike?size_types=women' },
        { title: 'Puma', urlKey: 'puma?size_types=women' },
        { title: 'Yeezy', urlKey: 'yeezy?size_types=women' },
      ],
    },
    {
      title: 'Shoes',
      link: 'shoes?size_types=women',
      submenu: [
        { title: 'UGG', urlKey: 'ugg?size_types=women' },
        { title: 'Gucci', urlKey: 'gucci-shoes?size_types=women' },
        { title: 'Prada', urlKey: 'prada-shoes?size_types=women' },
        { title: 'Hermes', urlKey: 'hermes-shoes?size_types=women' },
        { title: 'Chanel', urlKey: 'chanel-shoes?size_types=women' },
        {
          title: 'Christian Louboutin',
          urlKey: 'christian-louboutin?size_types=women',
        },
      ],
    },
    {
      title: 'Apparel',
      link: 'apparel?gender=women',
      submenu: [
        {
          title: 'Jacquemus',
          urlKey: 'other-apparel/jacquemus-apparel?gender=women',
        },
        { title: 'Skims', urlKey: 'other-apparel/skims?gender=women' },
        { title: 'The North Face', urlKey: 'the-north-face?gender=women' },
        {
          title: 'Adidas Ivy Park',
          urlKey: 'other-apparel/ivy-park?gender=women',
        },
        { title: 'Off-White', urlKey: 'off-white?gender=women' },
        { title: 'Palm Angels', urlKey: 'palm-angels?gender=women' },
        { title: 'CDG Play', urlKey: 'comme-des-garcons-play?gender=women' },
      ],
    },
    {
      title: 'Accessories',
      link: 'accessories?gender=women',
      submenu: [
        { title: 'Louis Vuitton', urlKey: 'louis-vuitton?gender=women' },
        { title: 'Telfar', urlKey: 'telfar?gender=women' },
        { title: 'Gucci', urlKey: 'gucci?gender=women' },
        { title: 'Chanel', urlKey: 'chanel?gender=women' },
        { title: 'Dior', urlKey: 'dior-accessories?gender=women' },
        {
          title: 'Marc Jacobs',
          urlKey: 'other-accessories/marc-jacobs?gender=women',
        },
        { title: 'Prada', urlKey: 'prada?gender=women' },
      ],
    },
    {
      title: 'Shop by Category',
      submenu: [
        { title: 'Tops', urlKey: 'search/apparel?gender=women&s=top' },
        { title: 'Dresses', urlKey: 'search/apparel?gender=women&s=dress' },
        {
          title: 'Jackets & Coats ',
          urlKey: 'search/apparel?gender=women&s=jacket',
        },
        { title: 'Tote Bags', urlKey: 'accessories/tote?gender=women' },
        {
          title: 'Shoulder Bags',
          urlKey: 'accessories/shoulder-bag?gender=women',
        },
        {
          title: 'Crossbody Bags',
          urlKey: 'accessories/crossbody?gender=women',
        },
        { title: 'Jewelry', urlKey: 'accessories/jewelry?gender=women' },
      ],
    },
  ],
};

const KIDS = {
  title: 'Kids',
  link: 'sneakers?size_types=child',
  submenu: [
    {
      title: 'Grade School Sneakers',
      link: 'sneakers?size_types=child',
      submenu: [
        { title: 'Air Jordan', urlKey: 'retro-jordans?size_types=child' },
        { title: 'adidas', urlKey: 'adidas?size_types=child' },
        { title: 'Converse', urlKey: 'converse?size_types=child' },
        { title: 'New Balance', urlKey: 'new-balance?size_types=child' },
        { title: 'Nike', urlKey: 'nike?size_types=child' },
        { title: 'Puma', urlKey: 'puma?size_types=child' },
        { title: 'Yeezy', urlKey: 'yeezy?size_types=child' },
      ],
    },
    {
      title: 'Preschool Sneakers',
      link: 'sneakers?size_types=preschool',
      submenu: [
        { title: 'Air Jordan', urlKey: 'retro-jordans?size_types=preschool' },
        { title: 'adidas', urlKey: 'adidas?size_types=preschool' },
        { title: 'Converse', urlKey: 'converse?size_types=preschool' },
        { title: 'Nike', urlKey: 'nike?size_types=preschool' },
        { title: 'UGG', urlKey: 'ugg/top-selling?size_types=child' },
        {
          title: 'Timberland',
          urlKey: 'timberland/top-selling?size_types=child',
        },
        { title: 'Yeezy', urlKey: 'yeezy?size_types=preschool' },
      ],
    },
    {
      title: 'Toddler/Infant Sneakers',
      link: 'sneakers?size_types=toddler',
      submenu: [
        { title: 'Air Jordan', urlKey: 'retro-jordans?size_types=toddler' },
        { title: 'adidas', urlKey: 'adidas?size_types=toddler' },
        {
          title: 'Converse',
          urlKey: 'converse/top-selling?size_types=toddler',
        },
        {
          title: 'New Balance',
          urlKey: 'new-balance/top-selling?size_types=toddler',
        },
        { title: 'Nike', urlKey: 'nike?size_types=toddler' },
        { title: 'Puma', urlKey: 'puma/top-selling?size_types=toddler' },
        { title: 'Yeezy', urlKey: 'yeezy?size_types=toddler' },
      ],
    },
    {
      title: 'Apparel',
      link: 'apparel?gender=kids',
      submenu: [
        { title: 'Nike', urlKey: 'nike-apparel?gender=kids' },
        { title: 'FOG Essentials', urlKey: 'fear-of-god?gender=kids' },
        { title: 'Kith', urlKey: 'kith?gender=kids' },
        { title: 'The North Face', urlKey: 'the-north-face?gender=kids' },
        { title: 'Moncler', urlKey: 'moncler?gender=kids' },
        { title: 'adidas', urlKey: 'search/apparel?s=adidas+kids' },
        { title: 'Yeezy', urlKey: 'yeezy-gap?gender=kids' },
      ],
    },
    {
      title: 'Viral Products',
      submenu: [
        {
          title: 'UGG Tasman Slippers',
          urlKey: 'ugg/slippers?size_types=child',
        },
        {
          title: 'Crocs x Cinnamon Toast Crunch',
          urlKey: 'crocs-classic-clog-cinnamon-toast-crunch-gs',
          isProduct: true,
        },
        {
          title: 'Nike Panda Dunk',
          urlKey: 'nike-dunk-low-retro-white-black-gs',
          isProduct: true,
        },
        {
          title: 'AJ1 Lost & Found',
          urlKey:
            'air-jordan-1-retro-high-og-chicago-reimagined-lost-and-found-gs',
          isProduct: true,
        },
        {
          title: 'Juice Wrld x Vlone Butterfly T-shirt',
          urlKey: 'juice-wrld-x-vlone-butterfly-t-shirt-white',
          isProduct: true,
        },
        {
          title: 'Nike Tech Fleece Full-Zip Hoodie',
          urlKey:
            'nike-sportswear-kids-tech-fleece-full-zip-hoodie-black-black',
          isProduct: true,
        },
        {
          title: 'FOG Essentials Kids Hoodie (SS22)',
          urlKey: 'fear-of-god-essentials-kids-hoodie-ss22-stretch-limo',
          isProduct: true,
        },
      ],
    },
  ],
};

export const MENU_ITEMS = {
  sneakers: SNEAKERS,
  shoes: SHOES,
  apparel: APPAREL,
  accessories: ACCESSORIES,
  electronics: ELECTRONICS,
  collectibles: COLLECTIBLES,
  men: MEN,
  women: WOMEN,
  kids: KIDS,
  'trading cards': TRADING_CARDS,
};

export const SECTION_BROWSE_WITH_GENDER: SectionItem = {
  title: 'Browse',
  subTitle: 'Browse All',
  subTitleLink: 'sneakers',
  subsections: [
    SNEAKERS,
    SHOES,
    APPAREL,
    ACCESSORIES,
    ELECTRONICS,
    TRADING_CARDS,
    COLLECTIBLES,
    MEN,
    WOMEN,
    KIDS,
  ],
};
